/** Channels this package owns. Defined here so consumers depend on the
 * owner rather than on a shared contracts barrel. */

export const SOCIAL_POST_GENERATION_PROJECTION_ID = "social-post-generation";
